import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTables, deleteTable, editTable, addTableNumber, openGlobalPopup } from "../../redux/action";
import { toast } from "react-toastify";
import ConfirmBox from "../../component/Popup/ConfirmBox";
import GlobalPopup from "../../component/Popup/GlobalPopup";
import "./TableSetting.css";
import EmptyScreen from "../../component/common/EmptyScreen";
import { useIsMobile } from "../../component/Hooks/useIsMobile.js";
import TableSettingMobile from "./TableSettingMobile.js";
import { useTranslation } from "react-i18next";
import { ButtonLoader } from "../../component/common/Loader";

const TableSetting = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState("single");
  const [tableNumber, setTableNumber] = useState("");
  const [capacity, setTableCapacity] = useState("");
  const [startTableNumber, setStartTableNumber] = useState("");
  const [endTableNumber, setEndTableNumber] = useState("");
  const [editingTable, setEditingTable] = useState(null);
  const [deleteTableId, setDeleteTableId] = useState('');
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { tables, tableSaving } = useSelector((state) => state.admin);
  const saveLockRef = useRef(false);
  console.log("tables", tables)

  useEffect(() => {
    dispatch(fetchTables());
  }, [dispatch]);

  useEffect(() => {
    if (!tableSaving) saveLockRef.current = false;
  }, [tableSaving]);

  // useEffect(() => { if (error) { 
  //   // Show error message if insert fails 
  //   toast.info(`Failed to add table(s): ${error}`); 
  // } }, [error]);

  const resetTableForm = () => {
    setEditingTable(null);
    setMode("single");
    setTableNumber("");
    setTableCapacity(0);
    setStartTableNumber("");
    setEndTableNumber("");
  };

  const openAddTablePopup = () => {
    resetTableForm();
    dispatch(openGlobalPopup("table-form"));
  };

  const openEditTablePopup = (table) => {
    if (!table) return;
    setEditingTable(table);
    setMode("single");
    setTableNumber(table.tableName);
    setTableCapacity(table.capacity || 0);
    setStartTableNumber("");
    setEndTableNumber("");
    dispatch(openGlobalPopup("table-form"));
  };

  const handleSave = () => {
    if (tableSaving || saveLockRef.current) return;

    if (!editingTable && mode === "single" && !tableNumber) {
      toast.info("Please enter a table number");
      return;
    }

    if (!editingTable && mode === "bulk" && (!startTableNumber || !endTableNumber)) {
      toast.info("Please enter start and end table numbers");
      return;
    }

    saveLockRef.current = true;

    if (editingTable) {
      dispatch(editTable({ ...editingTable, tableName: tableNumber, capacity }));
    } else if (mode === "single") {
      dispatch(addTableNumber(tableNumber, capacity));
    } else {
      dispatch(addTableNumber(null, capacity, startTableNumber, endTableNumber));
    }
  };


  const deleteRestoTable = (restaurantTableId) => {
    setDeleteTableId(restaurantTableId);
    dispatch(openGlobalPopup("confirm-box"));
  }

  return (
    <div className="container">
      <h1>Add Table</h1>
      {/* <p>Manage table count, generate QR, add, edit and delete table</p> */}

      <button className="add-button ui-page-add-button" onClick={openAddTablePopup}>
        Add New Table
      </button>

      {tables.length !== 0 ? (

<>
 {isMobile ? (<TableSettingMobile tables={tables} 
    onDelete={deleteRestoTable}
    onEdit={openEditTablePopup} />):
        (  < section className="list-section">
          <div className="table-container">
            <h3 style={{ padding: "0px 0px 0px 10px" }}>{t("Tables")} ({tables.length})
              {/* <span className="link">View QR-Code</span> */}
              {/* {loading && <p>Loading...</p>} */}
            </h3>
            <div className="table-wrapper">
              <table className="table">
                <thead>
                  <tr>
                    <th>Table Code / Number</th>
                    <th>Table Capacity</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(tables) && tables.map((t) => (
                    <tr key={t.restaurantTableId}>
                      <td>{"T-" + t.tableName}</td>
                      <td>{t.capacity || 0}</td>
                      <td className="action-icons">
                        <span
                          className="edit-icon link-btn"
                          title="Edit"
                          aria-label="Edit"
                          onClick={() => openEditTablePopup(t)}
                        // onClick={() => { const updatedTable = { ...t, tableName: prompt("Enter new table name", t.tableName) || t.tableName }; dispatch(editTable(updatedTable)); }}
                        >
                          ✎
                        </span>

                        <span
                          className="delete-icon link-btn danger"
                          title="Delete"
                          aria-label="Delete"
                          onClick={() => { deleteRestoTable(t.restaurantTableId) }}
                        >
                          ✖
                        </span>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>)}
</>
       
      )
        : <EmptyScreen message="No tables found for this restaurant. Please add tables." />}

      <GlobalPopup
        popupKey="table-form"
        title={editingTable ? "Edit Table" : "Add Table"}
        disableClose={tableSaving}
        onClose={resetTableForm}
        footer={(closePopup) => (
          <>
            <button
              type="button"
              className="popup-action-btn secondary"
              disabled={tableSaving}
              onClick={closePopup}
            >
              Cancel
            </button>
            <button
              type="button"
              className="popup-action-btn"
              disabled={tableSaving}
              aria-busy={tableSaving}
              onClick={handleSave}
            >
              {tableSaving && <span className="popup-button-spinner" aria-hidden="true" />}
              {tableSaving ? <ButtonLoader label="Saving..." /> : editingTable ? "Save Table" : mode === "bulk" ? "Add Tables" : "Add Table"}
            </button>
          </>
        )}
      >
        <div className="table-form-popup">
          {!editingTable && (
            <div className="table-form-tabs" role="tablist" aria-label="Table creation mode">
              <button
                type="button"
                role="tab"
                aria-selected={mode === "single"}
                className={mode === "single" ? "active" : ""}
                onClick={() => setMode("single")}
              >
                Single Table
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={mode === "bulk"}
                className={mode === "bulk" ? "active" : ""}
                onClick={() => setMode("bulk")}
              >
                Bulk Add Tables
              </button>
            </div>
          )}

          {mode === "single" && (
            <div className="table-form-fields">
              <label className="table-form-field">
                Table Number
                <input
                  value={tableNumber}
                  type="number"
                  min={0}
                  onChange={(e) => setTableNumber(e.target.value)}
                />
              </label>
              <label className="table-form-field">
                Table Capacity
                <input
                  value={capacity}
                  type="number"
                  min={0}
                  onChange={(e) => setTableCapacity(e.target.value)}
                />
              </label>
            </div>
          )}

          {mode === "bulk" && (
            <div className="table-form-fields">
              <div className="table-range-row">
                <label className="table-form-field">
                  Start Table Number
                  <input
                    value={startTableNumber}
                    type="number"
                    min={0}
                    onChange={(e) => setStartTableNumber(e.target.value)}
                  />
                </label>
                <label className="table-form-field">
                  End Table Number
                  <input
                    value={endTableNumber}
                    type="number"
                    min={0}
                    onChange={(e) => setEndTableNumber(e.target.value)}
                  />
                </label>
              </div>
              <label className="table-form-field">
                Table Capacity
                <input
                  value={capacity}
                  type="number"
                  min={0}
                  onChange={(e) => setTableCapacity(e.target.value)}
                />
              </label>
            </div>
          )}
        </div>
      </GlobalPopup>
      <ConfirmBox
        variant="delete"
        title="Are you sure you want to delete this table?"
        onConfirm={() => {
          dispatch(deleteTable(deleteTableId));
        }}
        onCancel={() => {
          setDeleteTableId('');
        }}
      />

    </div >
  );
};

export default TableSetting;
